import { Routes } from '@angular/router';
import { DictationDigitalPage } from './dictation-digital-page/dictation-digital-page';
import { DictationPage } from './dictation-page';
import { DictationPhysicalPage } from './dictation-physical-page/dictation-physical-page';

export const mechanicDictationRoutes: Routes = [
  {
    path: '',
    component: DictationPage,
  },
  {
    path: 'physical',
    component: DictationPhysicalPage,
  },
  {
    path: 'digital',
    component: DictationDigitalPage,
  },
];
